module.exports = __webpack_public_path__ + "img/console_example.31bf0101.png";